import { ConfigInterface } from 'swr';
import { DeepQueryParams, parseUrl, useWPApi, wpApi } from '@gik/core/api';
import PostsUrlBuilder, { RelationFilter } from './PostsUrlBuilder';
import WordpressPost from '@gik/core/models/wordpress/WordpressPost';

const path = 'posts';

export function getParams(relationFilters: RelationFilter<string[]>[], perPage = 4): DeepQueryParams {
  // prettier-ignore
  return new PostsUrlBuilder()
    .withPerPage(perPage)
    .withMultipleTaxonomiesMultipleItems(relationFilters)
    .params;
}

export function getPostsRelated(relationFilters: RelationFilter<string[]>[], perPage?: number) {
  const finalUrl = parseUrl(path, {
    deepQueryParams: getParams(relationFilters, perPage),
    qsStringifyOptions: {
      arrayFormat: 'indices',
    },
  });

  return wpApi.get(finalUrl);
}

export function usePostsRelated<Data = WordpressPost[]>(
  relationFilters: RelationFilter<string[]>[],
  perPage?: number,
  config?: ConfigInterface
) {
  const hasTaxonomyAndTerms =
    Array.isArray(relationFilters) &&
    relationFilters?.length > 0 &&
    relationFilters?.every?.(rf => rf.taxonomy && rf.terms);
  // important if there is no slug the path should be null so nothing will be fetched
  return useWPApi<Data>(relationFilters && hasTaxonomyAndTerms ? path : null, config, {
    deepQueryParams: relationFilters && getParams(relationFilters, perPage),
    qsStringifyOptions: {
      arrayFormat: 'indices',
    },
  });
}
